import React from 'react'

import { Content } from 'antd/es/layout/layout'
import PAQ from '../shop-front-component/PAQ'

import { useNavigate } from 'react-router-dom'
import { Breadcrumb, Image } from 'antd'
import { blindList, getProductByID, toBlind } from '../shop-front-component/ProductCollection'
import GenericProductPage from './GenericProductPage'

export default function PanellGlidBlindsPage() {
  return (
      GenericProductPage(getProductByID(40),toBlind)
  )
}
